import { atom, createStore } from 'jotai';

export type ActiveAuditChange = {
   _id: string;
   explanation: string;
   brandHouseId: string;
} | null;

/**
 * Jotai atom for storing the currently active audit change.
 * When set, a snackbar will be shown indicating a change is in progress.
 */
export const activeAuditChangeAtom = atom<ActiveAuditChange>(null);

/**
 * Shared store for accessing the atom outside of React components.
 * Used by Apollo Link to inject auditNoteId into mutations.
 */
export const auditChangeStore = createStore();

/**
 * Get the current active audit change value (for use outside React).
 */
export const getActiveAuditChange = (): ActiveAuditChange => {
   return auditChangeStore.get(activeAuditChangeAtom);
};

/**
 * Set the active audit change value (for use outside React).
 */
export const setActiveAuditChange = (value: ActiveAuditChange): void => {
   auditChangeStore.set(activeAuditChangeAtom, value);
};
